<ss-popup-confirm
  [type]="fields.type"
  [titleText]='fields.title'
  [helperText]='fields.helperText'
  [warningText]='fields.warningText'
  [submitText]='fields.submitText'
  (onCancel)="handleCancel($event)"
  (onSubmit)="handleSubmit($event)">
</ss-popup-confirm>